/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `:host,
* {
  box-sizing: border-box;
}

:host {
  font-size: 1rem;
}
:host .title {
  font-size: calc(12rem/14);
}
:host > .accordion {
  color: #007CC1;
  color: var(--davinci-color-primary, #007CC1);
  font-weight: 600;
  padding-right: calc(25rem/14);
  cursor: pointer;
  display: -webkit-box;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
          flex-direction: row;
  flex-wrap: nowrap;
  -webkit-box-pack: start;
          justify-content: flex-start;
  align-content: flex-start;
  -webkit-box-align: center;
          align-items: center;
  height: calc(34rem/14);
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
}
:host > .accordion > div {
  -webkit-box-flex: 0;
          flex: 0 0 auto;
}
:host > .accordion > svg {
  -webkit-box-flex: 0;
          flex: 0 0 auto;
  height: calc(24rem/14);
  width: calc(24rem/14);
  cursor: pointer;
  fill: #007CC1;
  fill: var(--davinci-color-primary, #007CC1);
}
:host > .accordion > svg.active {
  -webkit-transform: rotate(180deg);
          transform: rotate(180deg);
}
:host > .accordion > svg.prepend {
  -webkit-box-ordinal-group: 0;
          order: -1;
}
:host > .panel {
  display: none;
  overflow: hidden;
}
:host > .panel.open {
  display: block;
}`;
export { style };
//# sourceMappingURL=Collapse.style.js.map